'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import useProductListingProductsOnDisplay from 'hooks/useProductListingData/useProductListingProductsOnDisplay';

/**
 * Loads showroom display data and syncs it into the ShowroomDisplayContext.
 * Isolated in its own Suspense boundary so that a pending query here cannot
 * suspend the rest of the category page (product grid, sidebar, etc.).
 */
const ShowroomDataLoader = t0 => {
  const $ = _c(4);
  const {
    onLoad
  } = t0;
  const data = useProductListingProductsOnDisplay();
  let t1;
  let t2;
  if ($[0] !== data || $[1] !== onLoad) {
    t1 = () => {
      onLoad(data);
    };
    t2 = [data, onLoad];
    $[0] = data;
    $[1] = onLoad;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
};
ShowroomDataLoader.propTypes = {
  onLoad: PropTypes.func.isRequired
};
export default ShowroomDataLoader;